/* global axios */
import ApiClient from '../ApiClient';

class CaptainAnalyticsAPI extends ApiClient {
  constructor() {
    super('captain/analytics', { accountScoped: true });
  }

  getSummary({ inboxId, startDate, endDate } = {}) {
    return axios.get(`${this.url}/summary`, {
      params: {
        inbox_id: inboxId,
        start_date: startDate,
        end_date: endDate,
      },
    });
  }

  getTimeseries({ inboxId, startDate, endDate } = {}) {
    return axios.get(`${this.url}/timeseries`, {
      params: {
        inbox_id: inboxId,
        start_date: startDate,
        end_date: endDate,
      },
    });
  }

  getInsights({ inboxId, startDate, endDate, page, perPage } = {}) {
    return axios.get(`${this.url}/insights`, {
      params: {
        inbox_id: inboxId,
        start_date: startDate,
        end_date: endDate,
        page,
        per_page: perPage,
      },
    });
  }

  getTopics({ inboxId, startDate, endDate } = {}) {
    return axios.get(`${this.url}/topics`, {
      params: {
        inbox_id: inboxId,
        start_date: startDate,
        end_date: endDate,
      },
    });
  }

  runAnalysis({ inboxId, includeResolved, minHoursOpen } = {}) {
    return axios.post(`${this.url}/run_analysis`, {
      inbox_id: inboxId,
      include_resolved: includeResolved,
      min_hours_open: minHoursOpen,
    });
  }

  getPendingStats({ inboxId, startDate, endDate } = {}) {
    return axios.get(`${this.url}/pending_stats`, {
      params: {
        inbox_id: inboxId,
        start_date: startDate,
        end_date: endDate,
      },
    });
  }

  getInboxes() {
    return axios.get(`${this.url}/inboxes`);
  }

  updateInbox(inboxId, enabled) {
    return axios.patch(`${this.url}/inboxes/${inboxId}`, { enabled });
  }
}

export default new CaptainAnalyticsAPI();
